<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl />
      <div class="dashboard-status">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Dossier qualifié
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="purcentage"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">{{ purcentage }}%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section" v-if="comments !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Un commentaire a été déposé sur votre espace</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{comments}}</pre>
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="ofVacationDateAsString !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Congés annuels de votre centre de rattachement</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ ofVacationDateAsString }}</pre>
          </div>
        </div>
      </div>


      <div class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Bravo, votre candidature est qualifiée !<br> Il ne vous reste plus qu'à trouver un employeur vétérinaire et signer un contrat d'alternance !
          </div>
        </div>
      </div>

      <EmployerSearch :profilViewedCount=profilViewedCount />
    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'
import EmployerSearch from '@/components/Dashboard/EmployerSearch.vue'

export default {
  name: "DashboardQualified",
  components: {
    DashboardHeader,
    EmployerSearch
  },
  props: {
    firstname: String,
    purcentage: Number,
    profilViewedCount: Number,
    textDateConvocation: String,
    textCampusConvocation: String,
    comments: String,
    ofVacationDateAsString: String,
    profilePictureUrl: String,
  }
};
</script>
